
import { defineComponent } from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'prismjs/themes/prism-solarizedlight.css'
export default defineComponent({
  name: 'App'
})
